import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["to"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import url from 'url';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function buildBasenameLink(Link) {
  let basename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let slice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const BasenameLink = _ref => {
    let {
        to
      } = _ref,
      restProps = _objectWithoutProperties(_ref, _excluded);
    // coerce (string | object) to string
    const href = url.format(to);
    if (href.startsWith("".concat(basename, "/")) || href === basename) {
      return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
        to: slice ? href.slice(basename.length) : href
      }, restProps), {}, {
        "data-id": "basename-link_index_buildBasenameLink_Link"
      }));
    } else {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        _jsx("a", _objectSpread(_objectSpread({
          href: href
        }, restProps), {}, {
          "data-id": "basename-link_index_buildBasenameLink_a"
        }))
      );
    }
  };
  BasenameLink.displayName = "BasenameLink(".concat(basename, ")");
  return BasenameLink;
}